import { adminTypes } from "@admin/admin-types.di";
import type { AdminRepository } from "@admin/domain/repositories/admin.repository";
import { ToastManagerRepository } from "@core/domain/repositories/toast-manager.repository.ts";
import type { Nullable } from "@core/domain/types/nullable.type";
import { RecuperableModelError } from "@iot-platform/core";
import type {
    SpatialLevel,
    SpatialLevelUpdate,
} from "@station/domain/models/spatial-level.model";
import { inject, injectable } from "inversify";

@injectable()
export class SpatialLevelUpdateUseCase {
    constructor(
        @inject(adminTypes.repositories.AdminRepository)
        private readonly adminRepository: AdminRepository,
    ) {}

    async execute(
        spatialLevelId: string,
        spatialLevel: SpatialLevelUpdate,
    ): Promise<Nullable<SpatialLevel>> {
        const editResult = await this.adminRepository.updateSpatialLevel(
            spatialLevelId,
            spatialLevel,
        );

        return editResult.match(
            (spatialLevelEdited) => spatialLevelEdited,
            (error) => {
                if (error instanceof RecuperableModelError) {
                    ToastManagerRepository.warning(error.message);

                    return error.instance;
                }

                ToastManagerRepository.error(error.message);

                return null;
            },
        );
    }
}
